/* eslint-disable react/display-name */
import React, { memo, useEffect, useRef } from 'react';
import { LargeForecastCardContainer, LargeForecastCardWrap } from '../../styles';
import { LargeForecastCardTitle } from './largeForecastCardTitle';
import { HourCardDetails } from './hourCardDetails';
import { HourCardConditions } from './hourCardConditions';
import { HourlyForecastPeriodCompact, IForecastCard } from '../../common/types';
import { reduxConnect } from '../../../../common';
import { hourlyForecastScrollableViewId, forecastViewScrollHandler, hourlyForecastCardBaseId } from '../../common/utils';
import { lastHourCardLoadComplete } from '../../../../common/actions/hourlyForecastPageViewActions';

export const hourCarBaseId = 'autoscroll-';
interface HourCardLargeProps extends IForecastCard {
    lastHourCardLoadComplete(cardIndex: number): void;
    hourlyForecastPeriods: HourlyForecastPeriodCompact[];
    cardIndex: number;
    autoScrollToDaysHourCardIndex: number;
    isTablet: boolean;
    cardLocalTime: string;
    lastHourCardIndex: number;
}

const mapStoreStateToProps = (storeState: any) => {
    const { hourlyForecastPage } =  storeState || {};
    const { autoScrollToDaysHourCardIndex, hourlyForecastPeriods, lastHourCardIndex } = hourlyForecastPage || {};

    return {
        autoScrollToDaysHourCardIndex,
        hourlyForecastPeriods,
        lastHourCardIndex
    };
};

const mapDispatchToProps = {
    lastHourCardLoadComplete
};

export const HourCardLarge = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    hour, 
    day,
    temperature, 
    description,
    feelsLike, 
    humidity, 
    wind, 
    dewPoint, 
    iconCode, 
    cardIndex,
    lastHourCardLoadComplete,
    hourlyForecastPeriods,
    lastHourCardIndex,
    cardLocalTime,
    autoScrollToDaysHourCardIndex }: HourCardLargeProps) => {
    
    const hasPerformedAutoScroll = useRef<boolean>(false);

    useEffect(() => {
        const isLastCardIndex = cardIndex === hourlyForecastPeriods?.length - 1;
        const shouldUpdateLastCardIndex = lastHourCardIndex !== cardIndex;
        if (isLastCardIndex && shouldUpdateLastCardIndex) {
            lastHourCardLoadComplete(cardIndex);
        }
    }, [cardIndex, hourlyForecastPeriods, lastHourCardIndex]);

    useEffect(() => {
        const firstCardHourLocalTime = hourlyForecastPeriods?.[0]?.fdtolcl;
        const firstCardLIElement = document.getElementById(`${hourlyForecastCardBaseId}${firstCardHourLocalTime}`);
        const cardElementToFocus = document.getElementById(`${hourlyForecastCardBaseId}${cardLocalTime}`);
        const wrapperDiv = document.getElementById(hourlyForecastScrollableViewId);
        const isFocusableCard = cardIndex > 1;
        const shouldAutoScrollCard = autoScrollToDaysHourCardIndex === cardIndex;

        if (!hasPerformedAutoScroll.current && isFocusableCard && shouldAutoScrollCard && cardElementToFocus && firstCardLIElement && wrapperDiv) {
            const initHourCardOffset = firstCardLIElement?.offsetLeft;
            const focusHourCardOffset = cardElementToFocus?.offsetLeft;
            const scrollToPosition = focusHourCardOffset - initHourCardOffset;
            forecastViewScrollHandler(wrapperDiv, 300, scrollToPosition);
            hasPerformedAutoScroll.current = true;
        }
    }, [cardIndex, autoScrollToDaysHourCardIndex, hourlyForecastPeriods, cardLocalTime]);

    return (
        <LargeForecastCardContainer id={`${hourlyForecastCardBaseId}${cardLocalTime}`}>
            <LargeForecastCardTitle hour={hour} day={day} />
            <LargeForecastCardWrap>
                <HourCardConditions temperature={temperature} description={description} iconCode={iconCode} feelsLike={feelsLike} />
                <HourCardDetails humidity={humidity} wind={wind} dewPoint={dewPoint} />
            </LargeForecastCardWrap>
        </LargeForecastCardContainer>
    );
}));